<template>
    <BookForm :url="url" :model="model" :errors="errors" v-on:save="saveBook"></BookForm>
</template>

<script>
import BookForm from './BookForm'
export default {
  name: 'BookCreate',
  components: {BookForm},
  props: ['url'],
  data () {
    return {
      model: {
        author_id: null,
        selectables: {
          authors: [],
          categories: []
        }
      },
      errors: {}
    }
  },
  methods: {
    saveBook () {
      let self = this

      this.$http
        .post(this.url + `/create`, this.model, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.model = res.data.data
            this.$router.push('/admin/books/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Book Create'))

    let self = this
    this.$http
      .get(this.url + `/show/0`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.model = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/book/BookCreate.vue